import { Injectable, inject, NgZone } from '@angular/core';
import { ToastrService, IndividualConfig } from 'ngx-toastr';

/**
 * Angular v21 compatible toast wrapper service
 * Ensures all toast calls happen outside change detection cycle
 * to prevent ExpressionChangedAfterItHasBeenCheckedError
 */
@Injectable({
  providedIn: 'root'
})
export class ToastWrapperService {
  private readonly toastr = inject(ToastrService);
  private readonly ngZone = inject(NgZone);

  /**
   * Show success toast outside Angular zone
   */
  success(message: string, title?: string, override?: Partial<IndividualConfig>) {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.toastr.success(message, title, override);
        });
      }, 0);
    });
  }

  /**
   * Show error toast outside Angular zone
   */
  error(message: string, title?: string, override?: Partial<IndividualConfig>) {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.toastr.error(message, title, override);
        });
      }, 0);
    });
  }

  /**
   * Show info toast outside Angular zone
   */
  info(message: string, title?: string, override?: Partial<IndividualConfig>) {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.toastr.info(message, title, override);
        });
      }, 0);
    });
  }

  /**
   * Show warning toast outside Angular zone
   */
  warning(message: string, title?: string, override?: Partial<IndividualConfig>) {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.toastr.warning(message, title, override);
        });
      }, 0);
    });
  }

  /**
   * Clear all toasts
   */
  clear(toastId?: number) {
    this.toastr.clear(toastId);
  }
}
